export function isMobileApp() {
   return /iFixitMobileApp/i.test(navigator.userAgent);
}

// Decide "in the app" the way the rest of the site does; the user agent only adds the platform.
export function isAndroidMobileApp() {
   return App.isOnMobileApp && /iFixitMobileApp\/android/i.test(navigator.userAgent);
}
